import Http from '../base-http'


class EmployeeCosts extends Http {
  updateEmployeeCosts(userId, data) {
    return this.update(userId, data)
  }
}

const employeeCosts = new EmployeeCosts({
  modelUrlPrefix : 'user'
})

export default employeeCosts
